export default __webpack_public_path__ + "static/media/rickandmorty.a48089ac.png";